/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_Allow_ListInputs */

const en_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Customize</span> allowed Apps in deep focus</span>`)
};

const ar_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> <span style="[%2$s]">تخصيص </span> التطبيقات المسموح بها في التركيز العميق </span>`)
};

const de_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Anpassen</span> erlaubte Apps im Fokus</span>`)
};

const es_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Personaliza</span> las apps permitidas en el Modo de Concentración Profunda</span>`)
};

const fr_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Personnaliser</span> votre liste d'applications autorisées durant le mode de concentration profonde</span>`)
};

const it_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Personalizza </span> le app consentite in primo piano </span>`)
};

const ja_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">ディープフォーカス中に使用できるアプリを<span style="[%2$s]">カスタマイズ</span></span>`)
};

const ko_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">딥 포커스 모드에서 허용 앱을 <span style="[%2$s]">커스터마이징</span></span>`)
};

const pt_br_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Personalize</span> os aplicativos permitidos no Foco Total</span>`)
};

const ru_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Настраивайте</span> разрешённые приложения в глубокой фокусировке</span>`)
};

const th_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">ปรับแต่ง</span>แอปที่อนุญาตในโหมดโฟกัสเต็มที่</span>`)
};

const tr_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Derin odaklanmada izinli uygulamaları <span style="[%2$s]">özelleştir</span></span>`)
};

const zh_cn_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">自定义</span>深度专注可用软件</span>`)
};

const zh_tw_subscription_walkthrough_p1_content_allow_list = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">自訂</span>深度專注可用 App</span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\"><span style=\"[%2$s]\">Customize</span> allowed Apps in deep focus</span>" |
*
* @param {Subscription_Walkthrough_P1_Content_Allow_ListInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_allow_list = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_Allow_ListInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_Allow_ListInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_allow_list(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_allow_list(inputs)
	return zh_tw_subscription_walkthrough_p1_content_allow_list(inputs)
});